import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { PropertyContext, TourPage, TourSignupProps } from '../TourRouter';
import { TourNavigationButtons, useTourNavigation } from '../TourStateMachine';
import { IdVerificationTypes } from '../../../../../api/IdVerification';
import '../../../../../styles/IdVerification.css';
import { useContext, useEffect, useState } from 'react';
import { useFetch } from '../../../../../hooks/useFetch';
import { getIdVerificationStatus } from '../../../../../api/ProspectUserProfile';
import CheckpointIdVerification from './CheckpointIdVerification';
import LoadingOverlay from '../../../../common/LoadingOverlay';
import {
    PageProgress,
    ProspectVerificationStatus,
    ProspectVerificationType,
    updatePageProgress,
    updateProspectVerificationStatus
} from '../../../../../api/TourSignup';
import OnfidoVerification from './OnfidoVerification';
import { isMobile } from 'react-device-detect';
import CheckpointIdMobileLink from './CheckpointIdMobileLink';

const IdVerificationPage = (props: TourSignupProps) => {

    const [loaded, setLoaded] = useState(false);
    const [verificationRequired, setVerificationRequired] = useState(false);

    useEffect(() => {
        if (props.match.params.guestCardGuid !== undefined) {
            updatePageProgress(props.match.params.guestCardGuid, PageProgress.IdVerification);
        }
    }, []);

    const property = useContext(PropertyContext);
    if (!property) {
        return null;
    }

    const goForward = useTourNavigation(TourPage.IdVerification, props);

    if (property.idVerificationType === IdVerificationTypes.None) {
        goForward();
    }

    const { data: idVerificationData, loading } = useFetch(
        () => getIdVerificationStatus(property.idVerificationType),
        [],
        null
    );

    const updateVerificationStatus = (success: boolean) =>
        props.match.params.guestCardGuid &&
        updateProspectVerificationStatus(props.match.params.guestCardGuid, {
            verificationType: ProspectVerificationType.Id,
            verificationStatus: success
                ? ProspectVerificationStatus.Succeeded
                : ProspectVerificationStatus.Failed
        });

    useEffect(() => {
        if (
            idVerificationData &&
            (!idVerificationData.idVerified || idVerificationData.idExpired)
        ) {
            setVerificationRequired(true);
            setLoaded(true)
        } else if(idVerificationData &&
            idVerificationData.idVerified){
                goForward();
        }
    }, [idVerificationData]);

    if(!loaded){
        return <LoadingOverlay show={loading} inBootstrapColumn={true} />
    }

    return (
        <div className="id-verification-page">
            <h3 className="prospect-signup-header">ID Verification</h3>
            <LoadingOverlay show={loading} inBootstrapColumn={true} />
            {!loading &&
                (!verificationRequired ||
                    (idVerificationData && idVerificationData.idVerified && !idVerificationData.idExpired)) && (
                    <p className="font-weight-bold pb-2">
                        ID verification has already been completed. Click Next.
                    </p>
                )}
            {verificationRequired &&
            property.idVerificationType === IdVerificationTypes.CheckpointId ? (
                isMobile ? (
                    <CheckpointIdVerification
                        goForward={goForward}
                        updateVerificationStatus={updateVerificationStatus}
                    />
                ) : (
                    <CheckpointIdMobileLink property={property} />
                )
            ) : verificationRequired &&
              property.idVerificationType === IdVerificationTypes.Onfido ? (
                <OnfidoVerification
                    propertyInfo={property}
                    goForward={goForward}
                    guestCardGuid={props.match.params.guestCardGuid}
                    updateVerificationStatus={updateVerificationStatus}
                />
            ) : (
                <TourNavigationButtons props={props} page={TourPage.IdVerification} />
            )}
        </div>
    );
};

export default withRouter(IdVerificationPage);



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/verification/IdVerificationPage.tsx